
// const API_URL = 'https://eugene.eugenelouw.co.za:443';

// const API_URL = 'http://192.168.0.84:3003';
// const PDFWORKER_URL = `http://192.168.0.84:3000/pdf.worker.min.mjs` 
// const WS_URL = 'ws://192.168.0.84:3003'

// const API_URL = 'http://10.0.0.122:3003';
// const PDFWORKER_URL = `http://10.0.0.122:3000/pdf.worker.min.mjs`
// const WS_URL = 'ws://10.0.0.122:3003'

const API_URL = 'https://prs.eugenelouw.co.za'
const PDFWORKER_URL = `https://sign.eugenelouw.co.za/pdf.worker.min.mjs` 
const WS_URL = 'wss://prs.eugenelouw.co.za'

const API_KEY = process.env.REACT_APP_API_KEY;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;


//Employees

const EMPLOYEES_BASE_URL = `${API_URL}/api/v1/employees`;
const createPermanentContract_URL = `${API_URL}/api/v1/employees/createcontract`
const showContract_URL = `${API_URL}/api/v1/employees/`
const loadContract_URL = `${API_URL}/api/v1/employees/loadContract`
const signContract_URL = `${API_URL}/api/v1/employees/sign`
const SHOWID_URL = `${API_URL}/api/v1/employees/showID`
const SHOWIMAGE_URL = `${API_URL}/api/v1/employees/showImage`
const LOADIMAGE_URL = `${API_URL}/api/v1/employees/loadImage`

const SHOWEMPLOYEEFILE_URL = `${API_URL}/api/v1/employees/showEmployeeFile`
const LOADID_URL = `${API_URL}/api/v1/employees/loadID`
const LOADOTHER_URL = `${API_URL}/api/v1/employees/loadOther`

//Injury on duty
const IOD_BASE_URL = `${API_URL}/api/v1/ioditems`
const SHOWWCL2_URL = `${API_URL}/api/v1/ioditems`
const LOADIOD_OTHER_URL = `${API_URL}/api/v1/ioditems/loadOther`
const SHOWIODFILE_URL = `${API_URL}/api/v1/ioditems/showOtherFile`

//Payroll
const PAYROLLTRANSACTIONS_BASE_URL = `${API_URL}/api/v1/payrollTransactions`;
const PAYTYPES_URL = `${API_URL}/api/v1/paytypes`
const PAYRATES_URL = `${API_URL}/api/v1/payrates`
const ADDITIONS_URL = `${API_URL}/api/v1/additions`
const CURRENTPAYSLIPS_URL = `${API_URL}/api/v1/currentPayslips`
const TIMEATTENDANCE_URL = `${API_URL}/api/v1/timeAttendances`

//Stockitems
const STOCKITEMS_BASE_URL = `${API_URL}/api/v1/stockitems`;
const LOADSTOCKIMAGE_URL = `${API_URL}/api/v1/stockitems/loadImage`;
const STOCKTRANSACTIONS_BASE_URL = `${API_URL}/api/v1/transactions`;

//Warehouses
const WAREHOUSES_BASE_URL = `${API_URL}/api/v1/warehouses`;

//Users
const USERS_BASE_URL = `${API_URL}/api/v1/users`;

const UploadFiles_URL = `${API_URL}/api/v1/files/uploadFiles`
const Files_BASE_URL = `${API_URL}/api/v1/files`;
const showFile_URL = `${API_URL}/api/v1/files/`
const signFile_URL = `${API_URL}/api/v1/files/sign`
//Messages
const MESSAGES_BASE_URL = `${API_URL}/api/v1/messages`;

// For login and voting
const REQUEST_TOKEN_URL = `${API_URL}authentication/token/new?api_key=${API_KEY}`;
const LOGIN_URL = `${API_URL}/login`;
const SESSION_ID_URL = `${API_URL}authentication/session/new?api_key=${API_KEY}`;
const Register_URL = `${API_URL}/register`;
const LOGOUT_URL = `${API_URL}/logout`;

const IMAGE_BASE_URL = 'http://image.tmdb.org/t/p/';

// Sizes: w300, w780, w1280, original
const BACKDROP_SIZE = 'w1280';
// w92, w154, w185, w342, w500, w780, original
const POSTER_SIZE = 'w780';

export {
  
  EMPLOYEES_BASE_URL,
  API_URL,
  API_KEY,
  IMAGE_BASE_URL,
  BACKDROP_SIZE,
  POSTER_SIZE,
  REQUEST_TOKEN_URL,
  LOGIN_URL,
  SESSION_ID_URL,
  API_TOKEN,
  createPermanentContract_URL,
  showContract_URL,
  signContract_URL,
  UploadFiles_URL,
  Files_BASE_URL,
  showFile_URL,
  signFile_URL,
  Register_URL,
  PDFWORKER_URL,
  SHOWID_URL,
  SHOWEMPLOYEEFILE_URL,
  LOADID_URL,
  LOADOTHER_URL,
  loadContract_URL,
  STOCKITEMS_BASE_URL,
  STOCKTRANSACTIONS_BASE_URL,
  WAREHOUSES_BASE_URL,
  USERS_BASE_URL,
  SHOWIMAGE_URL,
  LOADIMAGE_URL,
  LOADSTOCKIMAGE_URL,
  IOD_BASE_URL,
  SHOWWCL2_URL,
  SHOWIODFILE_URL,
  LOADIOD_OTHER_URL,
  WS_URL,
  MESSAGES_BASE_URL,
  LOGOUT_URL,
  PAYROLLTRANSACTIONS_BASE_URL,
  PAYTYPES_URL,
  PAYRATES_URL,
  ADDITIONS_URL,
  CURRENTPAYSLIPS_URL,
  TIMEATTENDANCE_URL
};